import React from 'react'
import { navigate } from 'gatsby'
import './bannerHomeSection.scss'
import useMediaQuery from '../../../utils/useMediaQuery'
import DiamondButton from '../../atoms/diamond-button/diamond-button'

import character1 from '../../../assets/images/banner-home-section/personaje1x2.png'
import character2 from '../../../assets/images/banner-home-section/personaje2x2.png'
import character3 from '../../../assets/images/banner-home-section/personaje3x2.png'
import character4 from '../../../assets/images/banner-home-section/personaje4.png'
import character5 from '../../../assets/images/banner-home-section/personaje5.png'

import mobileCharacter2 from '../../../assets/images/banner-home-section/mobile/personaje2x2.png'
import mobileCharacter3 from '../../../assets/images/banner-home-section/mobile/personaje3x2.png'

import star from '../../../assets/images/banner-home-section/estrella.png'
import { TROPICALIZED } from '../../../constants/activity-constants'

const BannerHomeSection = () => {
  const isMobile = useMediaQuery(1024)
  const paragraph = (
    <p>
      Este mágico espacio está diseñado especialmente{' '}
      {TROPICALIZED ? 'para vos. Acá ' : 'para ti. Aquí '}
      podrás personalizar tus tarjetas navideñas como{' '}
      {TROPICALIZED ? 'querás' : 'quieras'}, y descargar stickers y wallpapers
      de tus personajes favoritos Nosotras.
    </p>
  )
  return (
    <div id="inicio" className="f-home-content-container">
      <div className="f-home-content-container__wrapper">
        {isMobile ? (
          <>
            <section className="f-home-content-container__mobileSection1">
              <img
                className="f-home-content-container__mobileSection1__character1"
                src={character4}
                alt="personaje 1"
              />
              <img
                className="f-home-content-container__mobileSection1__character2"
                src={mobileCharacter2}
                alt="estrella"
              />
              <img
                className="f-home-content-container__mobileSection1__character3"
                src={mobileCharacter3}
                alt="personaje 2"
              />
            </section>
            <section className="f-home-content-container__mobileSection2">
              <h2>¡Bienvenida a Nosotras Magic Box!</h2>

              {paragraph}
              <div className="f-home-content-container__mobileSection2__diamond">
                <DiamondButton
                  className="f-mb30 --small --colorBlue --hoverWhite"
                  onClick={() => {
                    navigate('#tarjetas')
                  }}
                />
              </div>
            </section>
          </>
        ) : (
          <>
            <section className="f-home-content-container__section1">
              <img
                className="f-home-content-container__section1__character1"
                src={character1}
                alt="personaje 1"
              />
              <img
                className="f-home-content-container__section1__star"
                src={star}
                alt="estrella"
              />
              <img
                className="f-home-content-container__section1__character2"
                src={character2}
                alt="personaje 2"
              />
              <img
                className="f-home-content-container__section1__character3"
                src={character3}
                alt="personaje 3"
              />
            </section>
            <section className="f-home-content-container__section2">
              <img
                className="f-home-content-container__section2__character4"
                src={character4}
                alt="personaje 4"
              />
              <h2>¡Bienvenida a Nosotras Magic Box!</h2>
              {paragraph}
              <div className="f-home-content-container__section2__diamond">
                <DiamondButton
                  className="f-mb30 --small --colorBlue --hoverWhite"
                  onClick={() => {
                    navigate('#tarjetas')
                  }}
                />
              </div>
              <img
                className="f-home-content-container__section2__character5"
                src={character5}
                alt="personaje 5"
              />
            </section>
          </>
        )}
      </div>
    </div>
  )
}

export default BannerHomeSection
